import utilities from '@/services/utilities/utilities';
import constants from '@/services/constants';
import _ from 'lodash';

export default {
  getFlopTone: function (flopCards) {
    let firstSuit = flopCards[0][1];
    let secondSuit = flopCards[1][1];
    let thirdSuit = flopCards[2][1];
    let suits = [
      firstSuit, secondSuit, thirdSuit
    ];
    let uniqueSuits = _.uniq(suits);

    if (uniqueSuits.length === 1) {
      return 'monotone';
    } else if (uniqueSuits.length === 2) {
      return 'twoToned';
    } else if (uniqueSuits.length === 3) {
      return 'rainbow';
    } else {
      throw new Error('Invalid flop tone.');
    }
  },
  getFlopTexture: function (flopCards) {
    let flopCardRanks = [
      flopCards[0][0], flopCards[1][0], flopCards[2][0]
    ];

    if (this._checkIfBingo(flopCardRanks)) {
      return 'bingo';
    } else if (this._checkIfPaired(flopCardRanks)) {
      return 'paired';
    } else if (this._checkIfTripleBroadway(flopCardRanks)) {
      return 'tripleBroadway';
    } else if (this._checkIfDoubleBroadway(flopCardRanks)) {
      return 'doubleBroadway';
    } else if (this._checkIfSingleBroadway(flopCardRanks)) {
      return 'singleBroadway';
    } else if (this._checkIfCoorddinatedMiddle(flopCardRanks)) {
      return 'coordinatedMiddle';
    } else if (this._checkIfCoordinatedSmall(flopCardRanks)) {
      return 'coordinatedSmall';
    } else if (this._checkIfRaggedy(flopCardRanks)) {
      return 'raggedy';
    } else {
      return 'other';
    }
  },
  _checkIfBingo: function (flopCardRanks) {
    let uniqueRanks = _.uniq(flopCardRanks);

    if (uniqueRanks.length === 1) {
      return true;
    }
    return false;
  },
  _checkIfPaired: function (flopCardRanks) {
    let uniqueRanks = _.uniq(flopCardRanks);

    if (uniqueRanks.length === 2) {
      return true;
    }
    return false;
  },
  __getNumBroadwayCards: function (flopCardRanks) {
    let numBroadwayCards = 0;

    flopCardRanks.forEach(function (flopCardRank) {
      if (constants.broadwayRanks.includes(flopCardRank)) {
        numBroadwayCards++;
      }
    });

    return numBroadwayCards;
  },
  _checkIfTripleBroadway: function (flopCardRanks) {
    let numBroadwayCards = this.__getNumBroadwayCards(flopCardRanks);

    if (numBroadwayCards === 3) {
      return true;
    }
    return false;
  },
  _checkIfDoubleBroadway: function (flopCardRanks) {
    let numBroadwayCards = this.__getNumBroadwayCards(flopCardRanks);

    if (numBroadwayCards === 2) {
      return true;
    }
    return false;
  },
  _checkIfSingleBroadway: function (flopCardRanks) {
    let numBroadwayCards = this.__getNumBroadwayCards(flopCardRanks);

    if (numBroadwayCards === 1) {
      return true;
    }
    return false;
  },
  _checkIfCoorddinatedMiddle: function (flopCardRanks) {
    flopCardRanks.sort(utilities.ranks.sortRanksDescendingCompareFunction);

    if (constants.coordinatedMiddleFlopRanks.includes(flopCardRanks.join(''))) {
      return true;
    }
    return false;
  },
  _checkIfCoordinatedSmall: function (flopCardRanks) {
    flopCardRanks.sort(utilities.ranks.sortRanksDescendingCompareFunction);

    if (constants.coordinatedSmallFlopRanks.includes(flopCardRanks.join(''))) {
      return true;
    }
    return false;
  },
  _checkIfRaggedy: function (flopCardRanks) {
    let spaceBetweenRanks = utilities.ranks.getSpaceBetweenRanks(flopCardRanks);

    if (spaceBetweenRanks > 4) {
      return true;
    }
    return false;
  },
  getSampleTexture: function (textureType) {
    if (textureType === 'triple broadway') {
      return this._getSampleTripleBroadwayTexture();
    } else if (textureType === 'double broadway') {
      return this._getSampleDoubleBroadwayTexture();
    } else if (textureType === 'single broadway') {
      return this._getSampleSingleBroadwayTexture();
    } else if (textureType === 'paired') {
      return this._getSamplePairedTexture();
    } else if (textureType === 'raggedy') {
      return this._getSampleRaggedyTexture();
    } else if (textureType === 'coordinated middle') {
      return this._getSampleCoordinatedMiddleTexture();
    } else if (textureType === 'coordinated small') {
      return this._getSampleCoordinatedSmallTexture();
    } else if (textureType === 'bingo') {
      return this._getSampleBingoTexture();
    } else {
      throw new Error('Invalid value of textureType.');
    }
  },
  _getSampleTripleBroadwayTexture: function () {
    return _.sample(['akq', 'akj', 'akt', 'aqj', 'aqt', 'ajt', 'kqj', 'kqt', 'kjt', 'qjt']);
  },
  _getSampleDoubleBroadwayTexture: function () {
    let firstTwoRanks = _.sample(['ak', 'aq', 'aj', 'at', 'kq', 'kj', 'kt', 'qj', 'qt', 'jt']);
    let thirdRank = _.sample(constants.nonBroadwayRanks);
    return firstTwoRanks + thirdRank;
  },
  _getSampleSingleBroadwayTexture: function () {
    let firstRank = _.sample(constants.broadwayRanks);
    let secondTwoRanks = _.sampleSize(constants.nonBroadwayRanks, 2);
    return firstRank + secondTwoRanks[0] + secondTwoRanks[1];
  },
  _getSamplePairedTexture: function () {
    let twoRanks = _.sampleSize(constants.ranks, 2);
    return twoRanks[0] + twoRanks[0] + twoRanks[1];
  },
  _getSampleRaggedyTexture: function () {
    let threeRanks;
    let rankOneIndex;
    let rankTwoIndex;
    let rankThreeIndex;
    let spaceBetweenRanks;

    while (true) {
      threeRanks = _.sampleSize(constants.nonBroadwayRanks, 3);
      spaceBetweenRanks = utilities.ranks.getSpaceBetweenRanks(threeRanks);

      if (spaceBetweenRanks > 4) {
        threeRanks.sort(utilities.ranks.sortRanksDescendingCompareFunction);
        return threeRanks[0] + threeRanks[1] + threeRanks[2];
      } else {
        // take another sample
      }
    }
  },
  _getSampleCoordinatedMiddleTexture: function () {
    return _.sample(constants.coordinatedMiddleFlopRanks);
  },
  _getSampleCoordinatedSmallTexture: function () {
    return _.sample(constants.coordinatedSmallFlopRanks);
  },
  _getSampleBingoTexture: function () {
    return _.sample(constants.bingoFlopRanks);
  },
  getSampleTone: function (toneType) {
    if (toneType === 'rainbow') {
      return this._getSampleRainbowTone();
    } else if (toneType === 'two-toned') {
      return this._getSampleTwoTonedTone();
    } else if (toneType === 'monotone') {
      return this._getSampleMonotoneTone();
    } else {
      throw new Error('Invalid tone type.');
    }
  },
  _getSampleRainbowTone: function () {
    let suits = _.sampleSize(constants.suits, 3);
    return suits[0] + suits[1] + suits[2];
  },
  _getSampleTwoTonedTone: function () {
    let suits = _.sampleSize(constants.suits, 2);
    return suits[0] + suits[1] + suits[1];
  },
  _getSampleMonotoneTone: function () {
    let suit = _.sample(constants.suits);
    return suit + suit + suit;
  },
};



// WEBPACK FOOTER //
// ./src/services/flop-info-helpers.js